export const GOAL_FORM = 0
export const COMMENT_FORM = 1
